import { render, staticRenderFns } from "./ComboboxTerritoriosIniciativasByEixo.vue?vue&type=template&id=4dcdf947"
import script from "./ComboboxTerritoriosIniciativasByEixo.vue?vue&type=script&lang=js"
export * from "./ComboboxTerritoriosIniciativasByEixo.vue?vue&type=script&lang=js"
import style0 from "./ComboboxTerritoriosIniciativasByEixo.vue?vue&type=style&index=0&id=4dcdf947&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports